import React from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";
import { SelectChangeEvent } from "@mui/material";

interface UpdateObj {
  glassType: string;
  glassAddon?: string;
}

const useGlassSelector = () => {
  const addToQuote = useStore((state) => state.addToQuote);

  const glassChoice = useStore((state) => state.quote.glassType);
  const i89 = useStore((state) => state.quote.i89coating);
  const breatherTubes = useStore((state) => state.quote.breatherTubes);
  const glassAddon = useStore((state) => state.quote.glassAddon);
  const glassAddonSide = useStore((state) => state.quote.glassAddonSide);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const checked = breatherTubes === "Yes";

  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    addToQuote({
      breatherTubes: event.target.checked === true ? "Yes" : "None",
    });
  };

  const handleAddonSideChange = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    addToQuote({ glassAddonSide: value });

    if (findRequired("Glass Surface Side")) {
      removeRequired("Glass Surface Side");
    }
  };

  const handleAddonChange = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;

    if (value.includes("i89")) {
      return addToQuote({
        i89coating: value,
        glassAddon: "",
      });
    }

    addToQuote({
      i89coating: "",
      glassAddon: value,
    });
  };

  const handleClick = (label: string) => {
    const checked = label === glassChoice;

    if (checked) return;

    let update: UpdateObj = { glassType: label };

    if (label === "LoE 272") {
      update["glassAddon"] = "";
    }

    addToQuote(update);
  };

  const selectValue = i89 ? i89 : glassAddon;

  return {
    selectValue,
    handleClick,
    handleAddonChange,
    handleAddonSideChange,
    handleCheck,
    checked,
    glassAddonSide,
    glassChoice,
    glassAddon
  };
};

export default useGlassSelector;
